/* ATHAR — generated shell (used by athar-preorder.js)
   Renders a macro of the quilted puffer shell: chunky horizontal baffles, stitched seams,
   soft puckers and wrinkles, lit by one overhead key light with a glossy nylon sheen.
   Returns the cold and the activated version from the same geometry, so the heat trace
   swaps colour without moving a single highlight. No photos are used. */
(function () {
  'use strict';

  function rng(seed) {
    var a = seed >>> 0;
    return function () {
      a = (a + 0x6D2B79F5) >>> 0;
      var t = a;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function hex(h) {
    h = String(h || '#808080').replace('#', '');
    if (h.length === 3) h = h.replace(/./g, '$&$&');
    var n = parseInt(h, 16);
    return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255];
  }

  /* A bank of plane waves in rotated coordinates, made separable in screen x / y:
     sin(A(x) + B(y)) = sinA·cosB + cosA·sinB. */
  function bank(R, n, lmin, lmax, amin, amax, W, H, cx, cy, c, s) {
    var waves = [], norm = 1 / Math.sqrt(n);
    for (var i = 0; i < n; i++) {
      var a = amin + R() * (amax - amin), lam = lmin + R() * (lmax - lmin), ph = R() * 6.2832;
      var kx = Math.cos(a) * 6.2832 / lam, ky = Math.sin(a) * 6.2832 / lam;
      var ax = kx * c + ky * s, ay = ky * c - kx * s, p0 = ph + kx * cx + ky * cy;
      var sA = new Float32Array(W), cA = new Float32Array(W), sB = new Float32Array(H), cB = new Float32Array(H);
      for (var x = 0; x < W; x++) { var A = (x - cx) * ax + p0; sA[x] = Math.sin(A); cA[x] = Math.cos(A); }
      for (var y = 0; y < H; y++) { var Bv = (y - cy) * ay; sB[y] = Math.sin(Bv); cB[y] = Math.cos(Bv); }
      waves.push([sA, cA, sB, cB]);
    }
    return { w: waves, k: norm };
  }
  function evalBank(b, x, y) {
    var s = 0, w = b.w;
    for (var i = 0; i < w.length; i++) { var q = w[i]; s += q[0][x] * q[3][y] + q[1][x] * q[2][y]; }
    return s * b.k;
  }

  /* W, H: pixel size to render. scale: device pixels per CSS pixel (keeps stitches crisp). */
  function render(W, H, cold, hot, opts) {
    opts = opts || {};
    var R = rng(opts.seed || 20261109);
    var ang = (opts.angle == null ? -7 : opts.angle) * Math.PI / 180;
    var c = Math.cos(ang), s = Math.sin(ang), cx = W / 2, cy = H / 2;
    var B = H / (opts.baffles || 2.75);
    var sc = opts.scale || 1;

    var wob = bank(R, 2, B * 5, B * 9, -0.3, 0.3, W, H, cx, cy, c, s);
    var puff = bank(R, 3, B * 1.8, B * 3.4, -0.2, 0.2, W, H, cx, cy, c, s);
    var puck = bank(R, 5, B * 0.10, B * 0.24, -0.5, 0.5, W, H, cx, cy, c, s);
    var broad = bank(R, 4, B * 0.9, B * 2.0, -1.2, 1.2, W, H, cx, cy, c, s);
    var envb = bank(R, 3, B * 0.8, B * 2.2, -1.2, 1.2, W, H, cx, cy, c, s);

    var N = W * H;
    var h = new Float32Array(N), V = new Float32Array(N), XR = new Float32Array(N);
    var i, x, y;
    for (y = 0; y < H; y++) {
      for (x = 0; x < W; x++) {
        i = y * W + x;
        var xr = cx + (x - cx) * c - (y - cy) * s;
        var yr = cy + (x - cx) * s + (y - cy) * c;
        var yy = yr + 0.08 * B * Math.sin(xr / W * Math.PI) - 0.04 * B + 0.04 * B * evalBank(wob, x, y);
        var v = (yy % B) / B; if (v < 0) v += 1;
        var sv = Math.sin(Math.PI * v); if (sv < 0) sv = 0;
        var p = Math.sqrt(sv);
        var pf = 1 + 0.10 * evalBank(puff, x, y);
        var edge = 1 - sv, e2 = edge * edge, e4 = e2 * e2;
        var env = 0.5 + 0.5 * evalBank(envb, x, y); env = env < 0 ? 0 : env > 1 ? 1 : env;
        h[i] = B * 0.46 * p * pf + B * 0.03 * evalBank(puck, x, y) * env * e4 + B * 0.013 * evalBank(broad, x, y);
        V[i] = v; XR[i] = xr;
      }
    }

    var cd = new ImageData(W, H), hd = new ImageData(W, H), C = cd.data, Hd = hd.data;
    var c0 = hex(cold), c1 = hex(hot);
    /* key light from above-left, rim from right */
    var L = [-0.28, -0.62, 0.73], ll = Math.hypot(L[0], L[1], L[2]); L = [L[0] / ll, L[1] / ll, L[2] / ll];
    var Hh = [L[0], L[1], L[2] + 1], hl = Math.hypot(Hh[0], Hh[1], Hh[2]); Hh = [Hh[0] / hl, Hh[1] / hl, Hh[2] / hl];
    var L2 = [0.8, 0.25, 0.35], l2 = Math.hypot(L2[0], L2[1], L2[2]); L2 = [L2[0] / l2, L2[1] / l2, L2[2] / l2];
    var g = rng(7);
    for (y = 0; y < H; y++) {
      var ym = y > 0 ? y - 1 : y, yp = y < H - 1 ? y + 1 : y, dy = yp - ym;
      for (x = 0; x < W; x++) {
        i = y * W + x;
        var xm = x > 0 ? x - 1 : x, xp = x < W - 1 ? x + 1 : x, dx = xp - xm;
        var gx = (h[y * W + xp] - h[y * W + xm]) / dx;
        var gy = (h[yp * W + x] - h[ym * W + x]) / dy;
        var cyl = XR[i] / W - 0.5;
        var nx = -gx - cyl * 0.45, ny = -gy, nz = 1;
        var nl = Math.sqrt(nx * nx + ny * ny + nz * nz); nx /= nl; ny /= nl; nz /= nl;
        var diff = nx * L[0] + ny * L[1] + nz * L[2]; if (diff < 0) diff = 0;
        var nh = nx * Hh[0] + ny * Hh[1] + nz * Hh[2]; if (nh < 0) nh = 0;
        var n2 = nh * nh, n3 = n2 * nh, n4 = n2 * n2, n8 = n4 * n4, n12 = n8 * n4, n16 = n8 * n8, n32 = n16 * n16, n64 = n32 * n32;
        var spec = n64 * 0.9 + n12 * 0.13 + n3 * 0.05;
        var rim = nx * L2[0] + ny * L2[1] + nz * L2[2]; rim = rim < 0 ? 0 : rim * rim * rim * 0.22;
        var v2 = V[i], sv2 = Math.sin(Math.PI * v2); if (sv2 < 0) sv2 = 0;
        var dist = Math.min(v2, 1 - v2) * B;
        var q = dist / (B * 0.035);
        var ao = (1 - 0.9 * Math.exp(-q * q)) * (0.45 + 0.55 * Math.sqrt(Math.sqrt(sv2)));
        var sd = (dist - B * 0.05) / (1.3 * sc);
        var st = Math.exp(-sd * sd) * (Math.sin((XR[i] / sc) * 6.2832 / 11) > 0.35 ? 0.12 : 0);
        var vx = (x / W - 0.5) / 0.64, vy = (y / H - 0.45) / 0.78, vr = vx * vx + vy * vy; if (vr > 1) vr = 1;
        var vign = 1 - 0.9 * vr;
        var shade = (0.08 + diff * 0.9 + rim) * ao;
        var grain = (g() - 0.5) * 0.018;
        var k = i * 4;
        for (var ch = 0; ch < 3; ch++) {
          var a0 = (c0[ch] * shade * 1.25 + spec * (0.45 + 0.55 * c0[ch]) * ao + st * (0.5 + 0.5 * c0[ch])) * vign + grain;
          var a1 = (c1[ch] * shade * 1.25 + spec * (0.45 + 0.55 * c1[ch]) * ao + st * (0.5 + 0.5 * c1[ch])) * vign + grain;
          C[k + ch] = a0 <= 0 ? 0 : a0 >= 1 ? 255 : a0 * 255;
          Hd[k + ch] = a1 <= 0 ? 0 : a1 >= 1 ? 255 : a1 * 255;
        }
        C[k + 3] = 255; Hd[k + 3] = 255;
      }
    }
    return { cold: cd, hot: hd };
  }

  window.AtharShell = { render: render };
})();
